import Dropdown from "@Components/forecast/Dropdown";
import WeatherWarningIcon from "@Components/forecast/location/WeatherWarningIcon";
import { useTranslations } from "@Context/TranslationContext/TranslationContext";
import { useWarnings } from "@Hooks/useWarnings";
import { priorityColor } from "@Utils/weatherWarning";

const WeatherWarning = () => {
  const { t } = useTranslations();
  const { warnings, maxPriority } = useWarnings();

  const dropdownContent = (
    <>
      {warnings.map((warning) => (
        <div
          key={warning.id}
          className="m:mb-6 m:flex m:gap-2 m:antialiased m:first:pt-[10px]">
          <WeatherWarningIcon type={warning.type} priority={warning.priority} />
          <div className="m:text-left">
            <h3 className="m:my-[1.5px] m:font-sans m:text-xl m:leading-normal m:font-medium m:tracking-0.2">
              {warning.title}
            </h3>
            <span
              data-testid={"weather-warning-text"}
              className="m:block m:text-xl m:leading-normal m:font-normal m:tracking-0.4 m:break-words">
              {warning.paragraph}
            </span>
          </div>
        </div>
      ))}
      <ul className="m:mt-8 m:antialiased">
        {Object.entries(priorityColor(t)).map(([key, priority]) => (
          <li
            key={key}
            className="m:mb-1 m:flex m:items-center m:gap-4 m:last:mb-0">
            <div
              className={`m:size-4 m:rounded-sm m:border-[0.5px] m:border-solid m:border-blue-950 ${priority.bg}`}
            />
            <span className="m:text-xl m:leading-normal m:font-normal m:tracking-0.4">
              {priority.legendText}
            </span>
          </li>
        ))}
      </ul>
    </>
  );

  return (
    warnings.length > 0 && (
      <div className="m:mx-4 m:md:mx-0 m:md:mt-8 m:md:w-full">
        <Dropdown
          title={t("forecast.weatherwarnings")}
          icon={<WeatherWarningIcon type={0} priority={maxPriority} />}
          offscreenTitle={priorityColor(t)[maxPriority].a11yLegendText}>
          {dropdownContent}
        </Dropdown>
      </div>
    )
  );
};

export default WeatherWarning;
